import { inject } from '@angular/core';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { forkJoin } from 'rxjs';
import { CommonService } from './modules/shared/services/common';

export const initialDataResolver = () => {
    const navigationService = inject(NavigationService);
    const commonService = inject(CommonService);

    // Fork join multiple API endpoint calls to wait all of them to finish
    return forkJoin([
        navigationService.get(),
        commonService.getCountries(),
    ]);
};
